import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import {
  Button,
  Container,
  Dropdown,
  Image,
  Menu,
  MenuItem,
} from 'semantic-ui-react';
import { useStore } from '../stores/store';

const NavBar: React.FC = observer(() => {
  const {
    userStore: { user, logout, IsLoggedIn },
  } = useStore();
  return (
    <Menu inverted fixed="top">
      <Container>
        <MenuItem as={NavLink} to="/" header>
          <img
            src="/assets/hubb.png"
            alt="logo"
            style={{ marginRight: '10px' }}
          />
          theHub
        </MenuItem>
        {IsLoggedIn && (
          <>
            <MenuItem name="Activities" as={NavLink} to="/activities" />
            <MenuItem name="Errors" as={NavLink} to="/errors" />
            <MenuItem>
              <Button
                positive
                content="Create activity"
                as={NavLink}
                to="/createActivity"
              />
            </MenuItem>
            <MenuItem position="right">
              <Image
                src={user?.image || '/assets/user.png'}
                avatar
                spaced="right"
              />
              <Dropdown pointing="top left" text={user?.displayName}>
                <Dropdown.Menu>
                  <Dropdown.Item
                    as={Link}
                    to={`/profiles/${user?.username}`}
                    text="My Profile"
                    icon="user"
                  />
                  <Dropdown.Item onClick={logout} text="Logout" icon="power" />
                </Dropdown.Menu>
              </Dropdown>
            </MenuItem>
          </>
        )}
      </Container>
    </Menu>
  );
});

export { NavBar };
